import React__default, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import ButtonIcon from '../Button/ButtonIcon/ButtonIcon.js';
import { SearchFieldContainer, IconContainer, SearchFieldInput, EndContainer } from './SearchField.styles.js';
import Loader from '../../Loader/index.js';

var SearchField = function SearchField(_ref) {
  var _ref$clearTitle = _ref.clearTitle,
    clearTitle = _ref$clearTitle === void 0 ? 'clear' : _ref$clearTitle,
    _ref$isFocused = _ref.isFocused,
    isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    onClear = _ref.onClear,
    onClick = _ref.onClick,
    onChange = _ref.onChange,
    value = _ref.value,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Search...' : _ref$placeholder,
    _ref$searchIconTitle = _ref.searchIconTitle,
    searchIconTitle = _ref$searchIconTitle === void 0 ? 'search' : _ref$searchIconTitle,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var inputRef = useRef(null);
  var theme = useTheme();
  useEffect(function () {
    var _inputRef$current;
    if (isFocused) (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
  }, [inputRef, isFocused]);
  return React__default.createElement(SearchFieldContainer, {
    "data-testid": testId
  }, React__default.createElement(IconContainer, null, React__default.createElement(ButtonIcon, {
    title: searchIconTitle,
    onClick: function onClick() {
      var _inputRef$current2;
      return inputRef === null || inputRef === void 0 || (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    },
    icon: "Search",
    variant: "ghost",
    size: "small"
  })), React__default.createElement(SearchFieldInput, {
    ref: inputRef,
    type: "text",
    onClick: onClick,
    onChange: onChange,
    value: value,
    placeholder: placeholder
  }), React__default.createElement(EndContainer, null, isLoading && React__default.createElement(Loader, {
    size: theme.sizing.medium,
    colour: "currentColor",
    testId: "loader"
  }), !isLoading && value.length > 0 && React__default.createElement(ButtonIcon, {
    title: clearTitle,
    onClick: onClear,
    variant: "ghost",
    icon: "Close",
    size: "small"
  })));
};
SearchField.propTypes = {
  clearTitle: PropTypes.string,
  isFocused: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  searchIconTitle: PropTypes.string,
  testId: PropTypes.string,
  value: PropTypes.string.isRequired
};

export { SearchField };
//# sourceMappingURL=SearchField.js.map
